// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"09607eee","452":"a698f8a5","487":"871822b9","744":"c0f8560a"}[chunkId] + ".chunk.js";
};